import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import UIButton from '../../UI/UIButton'

const MapButton = ({ action }) => (
  <UIButton
    icon={'icon-colonia'}
    id={'colony'}
    position={'position--absolute right bottom z-index1'}
    action={() => action()}
  />
)

MapButton.propTypes = {
  action: PropTypes.func,
}

export default connect()(MapButton)
